<template>
	<Row>
		<Container>
			<div>
				<div class="relative isolate overflow-hidden px-8 md:px-20 rounded-[20px]">
					<img
						v-if="image"
						:src="image"
						alt=""
						class="absolute inset-0 -z-10 h-full w-full object-cover"
					/>
					<!-- <div
						class="absolute inset-0 bg-gradient-to-r from-[rgba(38,41,48,0.8)] to-[rgba(38,41,48,0.8)] -z-9"
					></div> -->
					<div class="absolute inset-0 bg-black bg-opacity-70"></div>
					<div class="mx-auto">
						<div class="relative z-10 py-16 sm:py-32 lg:py-32">
							<div class="text-center md:text-left">
								<div class="">
									<img
										v-if="icon"
										class="mx-auto md:mx-0 mb-6 text-blue-900"
										:src="icon"
										alt="Top Features Icon"
									/>
								</div>
								<h3 class="text-xl lg:text-2xl font-bold mb-4 font-sauce-500">
									{{ subtitle }}
								</h3>
								<h2
									class="text-4xl font-bold tracking-tight text-white lg:text-6xl mb-6 font-sauce-500"
								>
									{{ title }}
								</h2>
								<div
									class="text-lg leading-8 text-gray-300 mb-[32px]"
									v-html="description"
								></div>

								<CtaButton
									:to="link"
									:type="ctaAppearence || 'secondary'"
									class="mt-10"
								>
									{{ btnText }}
								</CtaButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container>
	</Row>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
	subtitle: String,
	title: String,
	description: String,
	btnText: String,
	link: String,
	image: String,
	icon: String
});
</script>
